'use strict';

newsItem.$inject = ["NewsTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsItem = newsItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsItem(NewsTypes) {
    var clazz = function NewsItem() {
        var defaults = {
            id: 0,
            type: '',
            sellerId: 0,
            sellerName: '',
            isVipSeller: false,
            title: '',
            description: '',
            html: '',
            categoryId: 0,
            categoryLabel: '',
            categoryName: '',
            tags: [],
            links: [],
            banners: [],
            header: [],
            author: '',
            featuredImage: '',
            publishDate: '',
            shortDescription: '',
            gallery: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        getTypeLabel: function getTypeLabel(type) {
            var item = _lodash2.default.filter(NewsTypes, function (i) {
                return i.type === type;
            });
            return item && item.length > 0 ? item[0].label : null;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = resource.type;
        o.sellerId = resource.sellerId;
        o.sellerName = resource.sellerName;
        o.isVipSeller = resource.isVipSeller;
        o.title = resource.title;
        o.description = resource.description;
        o.html = resource.html;
        o.categoryId = resource.categoryId;
        o.tags = resource.tags;
        o.links = resource.links;
        o.banners = resource.banners;
        o.header = resource.header;
        o.author = resource.author;
        o.categoryLabel = resource.categoryLabel;
        o.categoryName = resource.categoryName;
        o.featuredImage = resource.featuredImage;
        o.publishDate = resource.publishDate;
        o.shortDescription = resource.shortDescription;
        o.gallery = resource.gallery;
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/newsItemModel.js
// module id = 758
// module chunks = 0